export const FilterOptions = [
  { key: "all", name: "client.all" },
  { key: "bookmarks", name: "client.myBookmarks" },
  { key: "popular", name: "client.popular" },
  { key: "most-viewed", name: "client.mostViewed" },
  { key: "recently-changed", name: "client.recentlyChanged" },
];

export const AssetFilterOptions = [
  { key: "all", name: "client.all" },
  { key: "bookmark", name: "client.myBookmarks" },
  { key: "popular", name: "client.popular" },
  { key: "mostviewed", name: "client.mostViewed" },
  { key: "recentlychanged", name: "client.recentlyChanged" },
];
